import { Button, ButtonRow, Heading, TextArea } from '@ksyos/design-system';
import type { IStepProps } from '../OsasPatientQuestionnaire';
import { translateKey } from '../../../../../translate';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';
import { ScoreInput } from './ScoreInput';

export function Step2(props: IStepProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading size="large">Videoconsult met de arts</Heading>
                </Stack>

                <ScoreInput
                    error={props.errors.get('explanationUnderstandable')}
                    handleChange={(value) => props.handleChange({ explanationUnderstandable: value })}
                    question="Was de uitleg van de arts begrijpelijk?"
                    value={props.customControlData.explanationUnderstandable}
                />

                <ScoreInput
                    error={props.errors.get('opportunityToAskQuestions')}
                    handleChange={(value) => props.handleChange({ opportunityToAskQuestions: value })}
                    question="Was er voldoende gelegenheid om vragen te stellen?"
                    value={props.customControlData.opportunityToAskQuestions}
                />

                <ScoreInput
                    error={props.errors.get('feltHelped')}
                    handleChange={(value) => props.handleChange({ feltHelped: value })}
                    question="Voelde je je goed geholpen?"
                    value={props.customControlData.feltHelped}
                />

                <Stack>
                    <StyledFormGroup
                        hasErrors={props.errors.has('videoConsultFreeText')}
                        label="Toelichting (optioneel)"
                        layout="vertical"
                    >
                        <TextArea
                            autoResize
                            error={
                                props.errors.get('videoConsultFreeText')
                                    ? translateKey('validation.' + props.errors.get('videoConsultFreeText'))
                                    : undefined
                            }
                            onChange={(e) => {
                                const videoConsultFreeText = e.target.value !== '' ? e.target.value : null;
                                props.handleChange({ videoConsultFreeText });
                            }}
                            placeholder="Wil je nog iets kwijt? Vermeld geen persoonlijke gegevens..."
                            value={props.customControlData.videoConsultFreeText || ''}
                        />
                    </StyledFormGroup>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.goToPreviousStep}
                        variant="outline"
                    >
                        Terug
                    </Button>
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                    >
                        Ga verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
